export default [
    {
        path: '/dashboard/classroom/help-centre',
        redirect: '/dashboard/help-centre/getting-started-guide'
    }
]